import { useAccount, useChainId, useSwitchChain } from 'wagmi'
import { monadTestnet, monadMainnet } from '../../config/rainbowkit'
import { cyberpunkTheme } from '../../styles/theme'

const SUPPORTED_IDS = new Set([monadTestnet.id, monadMainnet.id])

export default function WrongNetworkBanner() {
  const { isConnected } = useAccount()
  const chainId = useChainId()
  const { switchChain, isPending } = useSwitchChain()
  const isWrongNetwork = isConnected && !SUPPORTED_IDS.has(chainId)

  if (!isWrongNetwork) return null

  return (
    <div style={{
      position: 'sticky', top: 0, zIndex: 998,
      background: 'rgba(10, 5, 15, 0.97)',
      borderBottom: '2px solid rgba(255, 0, 64, 0.5)',
      boxShadow: '0 4px 20px rgba(255, 0, 64, 0.2)',
      padding: '0.5rem clamp(0.75rem, 3vw, 1.25rem)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      gap: '0.75rem', flexWrap: 'wrap',
    }}>
      <style>{`
        @keyframes wrongPulse { 0%,100%{opacity:1} 50%{opacity:0.5} }
      `}</style>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
        <span style={{
          width: '6px', height: '6px',
          background: '#ff0040',
          boxShadow: '0 0 6px #ff0040',
          animation: 'wrongPulse 1.4s ease-in-out infinite',
          flexShrink: 0,
        }} />
        <span style={{
          color: '#ff6680', fontSize: 'clamp(0.4rem, 1.2vw, 0.5rem)',
          fontFamily: cyberpunkTheme.fonts.display,
          letterSpacing: '0.02em',
        }}>
          ! WRONG NETWORK — SWITCH TO <span style={{ color: '#e0e0e0' }}>MONAD MAINNET</span> OR <span style={{ color: '#e0e0e0' }}>TESTNET</span>
        </span>
      </div>
      <button
        type="button"
        disabled={isPending}
        onClick={() => switchChain({ chainId: monadMainnet.id })}
        style={{
          padding: '0.35rem 0.75rem',
          background: 'rgba(255, 0, 64, 0.08)',
          border: '2px solid rgba(255, 0, 64, 0.5)',
          borderRadius: '4px',
          color: '#ff6680',
          fontSize: 'clamp(0.38rem, 1vw, 0.45rem)',
          cursor: isPending ? 'wait' : 'pointer',
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          transition: 'all 0.2s ease',
          fontFamily: cyberpunkTheme.fonts.display,
          opacity: isPending ? 0.6 : 1,
          minHeight: '36px',
        }}
      >
        {isPending ? 'SWITCHING...' : '► SWITCH TO MONAD'}
      </button>
    </div>
  )
}
